import Styled from 'styled-components';

export const AssigneeGroupWrapper = Styled.div`
	display: flex;

	flex-wrap: no-wrap;
	overflow: hidden;
	align-items: center;
	font-size: 11px;
	/* font-weight: 500; * */
	/* color: $color-white; */
	/* letter-spacing: -0.5px; */
	height: 26px;
	/* text-align: center; */
	justify-content: ${props => (props.alignStart ? 'flex-start' : 'flex-end')};
`;

const getColor = props => {
	switch (props.type) {
		case 'counter':
			return '#3f4b57';
		case 'initials':
			return '#6e0fea';
	}
};
export const Hexagon = Styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	background-color: ${props => getColor(props)};
	font-weight: 500;
	text-transform: uppercase;
	color: white;
	font-size: 9px;
	&:before,
	&:after {
		content: '';
		position: absolute;
		width: 0;
		left: 0px;
		border-left: 12.5px solid transparent;
		border-right: 12.5px solid transparent;
	}
	&:before {
		bottom: 100%;
		border-bottom: ${props => `7.22px solid ${getColor(props)}`};
	}

	&:after {
		top: 100%;
		width: 0;
		border-top: ${props => `7.22px solid ${getColor(props)}`};
	}
	&.EXTRA_SMALL {
		width: 21px;
		height: 12.12px;
		margin: 6.06px 0;
		&:before,
		&:after {
			border-left: 10.5px solid transparent;
			border-right: 10.5px solid transparent;
		}
		&:before {
			border-bottom: ${props => `6.06px solid ${getColor(props)}`};
		}
		&:after {
			border-top: ${props => `6.06px solid ${getColor(props)}`};
		}

	}
	&.SMALL {
		width: 23px;
		height: 13.28px;
		margin-right: 0px;
		&:before,
		&:after {
			border-left: 11.5px solid transparent;
			border-right: 11.5px solid transparent;
		}
		&:before {
			border-bottom: ${props => `6.64px solid ${getColor(props)}`};
		}
		&:after {
			border-top: ${props => `6.64px solid ${getColor(props)}`};
		}

	}
`;

export const AssigneeWrapper = Styled.div`
	margin-right: ${props => props.useMargin && (props.iconSpaceBetween ? `${props.iconSpaceBetween}px` : '-7px')};
	height: 26px;
	width: 26px;
	display: flex;
	align-items: center;
`;

export const Image = Styled.img`
	height: 26px;
	
`;

export const AssigneeGroupText = Styled.span`
	margin-left: 4px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
